import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Wrench } from 'lucide-react';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = [
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/xugcj37y_image.png",
      title: "Ford Explorer Repair & Maintenance",
      description: "Expert diagnostics, mechanical repairs, and professional maintenance for your Ford Explorer."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/r9ws4es9_image.png",
      title: "Porsche Carrera S Service",
      description: "Specialist diagnostics, maintenance, and precision repairs for exceptional Porsche performance."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/llfs8r96_image.png",
      title: "Mercedes-Benz Repair & Maintenance",
      description: "Expert diagnostics, mechanical repairs, and precision maintenance by our specialist technicians."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/klyouxh3_image.png",
      title: "Porsche Diagnostics & Repair",
      description: "Advanced diagnostics and precision repair services for optimal Porsche performance."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/mfyuqe31_image.png",
      title: "GLE 350 Repair & Maintenance",
      description: "Expert diagnostics, servicing, and precision repairs for reliable Mercedes-Benz performance."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/two3clxq_PHOTO-2026-07-27-11-25-59%202.jpg",
      title: "BMW 530i xDrive Repair",
      description: "Expert diagnostics and precision repairs completed by our BMW specialist technicians."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/0dohbj72_PHOTO-2026-07-23-19-12-42.jpg",
      title: "Porsche 911 Service",
      description: "Professional maintenance, diagnostics & repairs for peak performance."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/uqjwzh6t_PHOTO-2026-07-27-11-26-01%203.jpg",
      title: "Corvette C8 Specialists",
      description: "Expert diagnostics, maintenance & precision repairs by performance car specialists."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/6vntmvdg_PHOTO-2026-07-27-11-26-01%204.jpg",
      title: "Mercedes-AMG C43 Specialists",
      description: "Professional maintenance and repairs to keep your AMG performing at its best."
    },
    {
      url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/efvdgmhx_PHOTO-2026-07-27-11-26-01%205.jpg",
      title: "Mercedes-Benz Specialists",
      description: "From routine servicing to major repairs, your Mercedes is in expert hands."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/k177cjtk_92a63419-2453-4bb2-baf3-92e7e8d205a6.jpg",
      title: "BMW 640i Specialists",
      description: "Advanced diagnostics and premium repairs for the BMW 640i."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/1jt3ptsp_220f1ac1-38f1-4e46-8289-469f11b47a0b.jpg",
      title: "Ferrari California Service",
      description: "From routine maintenance to advanced repairs, your Ferrari is in expert hands."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/9j0ibvfk_6097add2-4faf-45d5-b3a1-3ee2358c99f5.jpg",
      title: "G-Class Repair & Maintenance",
      description: "From routine servicing to major repairs, your G-Class is in expert hands."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/7845uczo_58677ccd-9e5c-48fa-ba38-4bf67628e5fd.jpg",
      title: "BMW & Mercedes-Benz Specialists",
      description: "Expert diagnostics, maintenance & repairs for all BMW and Mercedes-Benz models."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/caiy57fa_ee553258-4834-40dd-927f-3a0c70d2fddd.jpg",
      title: "Luxury Vehicle Specialists",
      description: "Professional service, advanced diagnostics & precision repairs for premium vehicles."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/hk35spp0_17bfbdeb-adca-4cfd-a883-28e651e9b571.jpg",
      title: "Mercedes-Benz Service Excellence",
      description: "Day or night, our expert technicians keep your Mercedes performing at its best."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/5rb2868n_e2626a6f-bdf7-4034-910e-6fcbd804c2d9.jpg",
      title: "Volkswagen Golf GTI Specialists",
      description: "Advanced diagnostics and expert repairs for Golf GTI and all Volkswagen models."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/b0tf9mn3_f6af8598-c131-40fe-9915-e11391481c0c.jpg",
      title: "Mercedes-Benz S560 Service",
      description: "Professional maintenance and repairs to keep your S-Class performing at its best."
    },
    {
      url: "https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/eqt87ttb_f84f8ef8-594f-450d-9c4f-849789afbc35.jpg",
      title: "Mercedes-Benz Computer Diagnostics",
      description: "Professional diagnostic solutions to identify and resolve issues with confidence."
    }
  ];

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(galleryImages[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Our Work</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Real Repairs. Real Results.
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            See the quality of our work on luxury and performance vehicles. From engine repairs to complete maintenance, we deliver excellence.
          </p>
        </div>

        {/* Gallery Grid - 4 columns on desktop, 2 columns on mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-7xl mx-auto">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl cursor-pointer aspect-square"
              onClick={() => openLightbox(index)}
            >
              {/* Image */}
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Overlay - Darker on mobile for better text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              
              {/* Text Overlay - Simplified for mobile, full on desktop */}
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-6 transition-transform duration-300 sm:transform sm:translate-y-4 sm:group-hover:translate-y-0">
                {/* Badge - Hidden on mobile, visible on desktop */}
                <div className="hidden sm:flex items-center space-x-2 mb-2">
                  <Wrench className="w-4 h-4 text-red-600" />
                  <span className="text-red-600 text-sm font-semibold">Professional Work</span>
                </div>
                {/* Title - Larger and bolder on mobile */}
                <h3 className="text-white font-bold text-lg sm:text-xl mb-1 drop-shadow-lg">{image.title}</h3>
                {/* Description - Hidden on mobile, shows on desktop hover */}
                <p className="hidden sm:block text-gray-300 text-sm sm:opacity-0 sm:group-hover:opacity-100 transition-opacity duration-300">
                  {image.description}
                </p>
              </div>

              {/* Hover Effect Border */}
              <div className="absolute inset-0 border-4 border-red-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg mb-4">
            Want your car to receive the same level of care?
          </p>
          <button
            onClick={() => {
              const message = "Hi Think Mechanic, I want to book a service and claim my 15% website discount!";
              const whatsappNumber = '+971566671468';
              const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;
              window.open(whatsappUrl, '_blank');
            }}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-200 shadow-lg hover:shadow-red-600/50"
          >
            Book your Service & Get 15% OFF
          </button>
          <p className="text-gray-600 text-sm mt-3">
            ✨ Special discount for website visitors
          </p>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-red-600 transition-colors z-50"
          >
            <X className="w-10 h-10" />
          </button>

          {/* Previous Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-4 text-white hover:text-red-600 transition-colors z-50"
          >
            <ChevronLeft className="w-12 h-12" />
          </button>

          {/* Next Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-4 text-white hover:text-red-600 transition-colors z-50"
          >
            <ChevronRight className="w-12 h-12" />
          </button>

          {/* Image */}
          <div
            className="max-w-5xl max-h-[90vh] relative"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <div className="mt-4 text-center">
              <h3 className="text-white font-bold text-2xl mb-2">{selectedImage.title}</h3>
              <p className="text-gray-300">{selectedImage.description}</p>
              <p className="text-gray-500 text-sm mt-2">
                Image {currentIndex + 1} of {galleryImages.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
